import ws from '../utils/ws';

/* Actions */

/* cellId travels on meta so the reducer can drop a response that arrives after the view has moved
   on to a different cell */
export const findCellNotes = cellId => dispatch =>
  dispatch({
    type: FIND_CELL_NOTES,
    payload: ws.get(`/cells/${cellId}/notes/`),
    meta: { cellId }
  });

export const createCellNote = (cellId, cellNote) => dispatch =>
  dispatch({
    type: CREATE_CELL_NOTE,
    payload: ws.post(`/cells/${cellId}/notes/`, cellNote),
    meta: { cellId }
  });

export const saveCellNote = (noteId, cellNote) => dispatch =>
  dispatch({
    type: SAVE_CELL_NOTE,
    payload: ws.post(`/cell_notes/${noteId}/save`, cellNote)
  });

export const deleteCellNote = noteId => dispatch =>
  dispatch({
    type: DELETE_CELL_NOTE,
    payload: ws.post(`/cell_notes/${noteId}/delete`, {})
  });

/* Action Constants */

export const FIND_CELL_NOTES = 'FIND_CELL_NOTES';
export const FIND_CELL_NOTES_PENDING = 'FIND_CELL_NOTES_PENDING';
export const FIND_CELL_NOTES_FULFILLED = 'FIND_CELL_NOTES_FULFILLED';
export const FIND_CELL_NOTES_REJECTED = 'FIND_CELL_NOTES_REJECTED';

export const CREATE_CELL_NOTE = 'CREATE_CELL_NOTE';
export const CREATE_CELL_NOTE_PENDING = 'CREATE_CELL_NOTE_PENDING';
export const CREATE_CELL_NOTE_FULFILLED = 'CREATE_CELL_NOTE_FULFILLED';

export const SAVE_CELL_NOTE = 'SAVE_CELL_NOTE';
export const SAVE_CELL_NOTE_PENDING = 'SAVE_CELL_NOTE_PENDING';
export const SAVE_CELL_NOTE_FULFILLED = 'SAVE_CELL_NOTE_FULFILLED';

export const DELETE_CELL_NOTE = 'DELETE_CELL_NOTE';
export const DELETE_CELL_NOTE_PENDING = 'DELETE_CELL_NOTE_PENDING';
export const DELETE_CELL_NOTE_FULFILLED = 'DELETE_CELL_NOTE_FULFILLED';
